import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ChatPage = () => {
  const navigate = useNavigate();

  // Initialize the chat widget
  useEffect(() => {
    // Check if we're in the browser
    if (typeof window === 'undefined') return;

    // Set up the configuration
    window.intergramId = "7429566451";
    window.intergramCustomizations = {
      titleClosed: 'Need help?',
      titleOpen: 'LightTrade Support',
      introMessage: 'Hello! How can we help you today?',
      autoResponse: 'Connecting you with our support team...',
      autoNoResponse: 'Our team is currently busy. Please leave a message and we\'ll get back to you soon!',
      mainColor: "#00A3FF",
      alwaysUseFloatingButton: true
    };

    // Create script element for the widget
    const script = document.createElement('script');
    script.id = 'intergram-widget';
    script.src = 'https://www.intergram.xyz/js/widget.js';
    script.async = true;
    
    // Handle script load
    script.onload = () => {
      console.log('Chat widget script loaded successfully');
      const chatIframe = document.getElementById('intergram-iframe');
      if (chatIframe) {
        chatIframe.style.display = 'block';
      }
    };
    
    // Handle script error
    script.onerror = (error) => {
      console.error('Failed to load chat widget script:', error);
    };

    // Add script to the document
    document.body.appendChild(script);

    // Clean up function
    return () => {
      console.log('Cleaning up chat widget');
      const widgetScript = document.getElementById('intergram-widget');
      if (widgetScript) widgetScript.remove();
      const iframe = document.getElementById('intergram-iframe');
      if (iframe) iframe.remove();
      delete window.intergramId;
      delete window.intergramCustomizations;
    };
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      textAlign: 'center',
      background: 'linear-gradient(135deg, #00FFD0, #00A3FF, #FF61F6, #fff)'
    }}>
      <h1 style={{
        color: '#2c5364',
        marginBottom: '2rem',
        fontFamily: 'Outfit, sans-serif',
        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        LightTrade Support Chat
      </h1>
      <div style={{
        maxWidth: '600px',
        width: '100%',
        padding: '2rem',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        marginBottom: '2rem'
      }}>
        <p style={{ marginBottom: '1.5rem' }}>
          Our support team is ready to assist you. The chat widget should appear in the bottom right corner of this page.
        </p>
        <p style={{ marginBottom: '1.5rem' }}>
          If you don't see the chat bubble, please ensure that:
        </p>
        <ul style={{
          textAlign: 'left',
          margin: '0 auto',
          maxWidth: '400px',
          marginBottom: '1.5rem'
        }}>
          <li>Pop-ups are allowed for this site</li>
          <li>No browser extensions are blocking the chat</li>
          <li>You're not in incognito/private browsing mode</li>
        </ul>
        <button
          onClick={() => window.location.reload()}
          style={{
            backgroundColor: '#00A3FF',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            marginTop: '1rem',
            transition: 'all 0.3s ease',
            ':hover': {
              backgroundColor: '#0088cc',
              transform: 'translateY(-2px)'
            }
          }}
        >
          Reload Chat Widget
        </button>
      </div>
    </div>
  );
};

export default ChatPage;